class EventsList extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = this.querySelectorAll('[data-action]');
    this.eventCards = this.querySelectorAll('.event-card');
    this.countDisplay = this.querySelector('.events-count');

    this.updateEventCount('upcoming');

    this.init();
  }

  init() {
    this.filterButtons.forEach(button => {
      button.addEventListener('click', () => this.handleFilterClick(button));
    });

    this.filterEvents('upcoming');
  }

  handleFilterClick(clickedButton) {
    this.filterButtons.forEach(button => {
      button.classList.toggle('active', button === clickedButton);
    });

    const filter = clickedButton.dataset.filter;
    console.log(filter)
    this.filterEvents(filter);
    this.updateEventCount(filter);
  }

  filterEvents(filter) {
    console.log(filter)
    this.eventCards.forEach(card => {
      const isPast = card.dataset.eventStatus === 'past';
      if (filter === 'past') {
        card.style.display = isPast ? 'block' : 'none';
      } else {
        card.style.display = isPast ? 'none' : 'block';
      }
    });
  }

  updateEventCount(filter) {
    const visibleEvents = Array.from(this.eventCards).filter(card => {
      const isPast = card.dataset.eventStatus === 'past';
      return (filter === 'past' && isPast) ||
             (filter === 'upcoming' && !isPast);
    });


    if (this.countDisplay) {
      this.countDisplay.textContent = visibleEvents.length + ' Events';
    }
  }
}

if (!customElements.get('events-list')) {
  customElements.define('events-list', EventsList);
}